import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

import { AddressRaw } from '@digital-platform/rs-cms/domain';

const RS_ADDRESS_KEY = 'rsServiceAddress';
const RS_POSTALCODE_KEY = 'rsLocPc';
const RS_ADDRESS_LINE1_KEY = 'rsLocAdd';
const RS_CITY_KEY = 'rsLocCty';
const RS_STATE_KEY = 'rsLocSt';
const RS_LAWSON_KEY = 'rsLocLawson';

@Injectable({
  providedIn: 'root',
})
export class AddressLookupService {
  private cookieService: CookieService = inject(CookieService);

  public loadStoredAddress(): AddressRaw | undefined {
    const serviceAddressStr = localStorage.getItem(RS_ADDRESS_KEY);
    if (serviceAddressStr) {
      return JSON.parse(serviceAddressStr);
    }

    return;
  }

  public storeAddress(address?: AddressRaw, lawsonDivision?: string): void {
    this.clearAddress();

    if (address) {
      const sevenDaysFromNowDateObj = new Date(
        Date.now() + 7 * 24 * 3600 * 1000
      );

      if (address.postalCode) {
        this.cookieService.set(RS_POSTALCODE_KEY, address.postalCode, {
          expires: sevenDaysFromNowDateObj,
        });
      }

      if (address.addressLine1) {
        this.cookieService.set(RS_ADDRESS_LINE1_KEY, address.addressLine1, {
          expires: sevenDaysFromNowDateObj,
        });
      }

      if (address.city) {
        this.cookieService.set(RS_CITY_KEY, address.city, {
          expires: sevenDaysFromNowDateObj,
        });
      }

      if (address.stateCode) {
        this.cookieService.set(RS_STATE_KEY, address.stateCode, {
          expires: sevenDaysFromNowDateObj,
        });
      }

      if (lawsonDivision) {
        this.cookieService.set(RS_LAWSON_KEY, lawsonDivision, {
          expires: sevenDaysFromNowDateObj,
        });
      }

      localStorage.setItem(RS_ADDRESS_KEY, JSON.stringify(address));
    }
  }

  private clearAddress(): void {
    this.cookieService.delete(RS_POSTALCODE_KEY);
    this.cookieService.delete(RS_ADDRESS_LINE1_KEY);
    this.cookieService.delete(RS_CITY_KEY);
    this.cookieService.delete(RS_STATE_KEY);

    localStorage.removeItem(RS_ADDRESS_KEY);
  }
}
